import { render, staticRenderFns } from "./Seconded.vue?vue&type=template&id=1cf50848"
import script from "./Seconded.vue?vue&type=script&lang=js"
export * from "./Seconded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports